import React from 'react';
import { withRouter, Link } from 'react-router-dom';

import ContentLayout from 'component/page/content';


class Page extends React.Component {
  render (){
    return (
      <ContentLayout id="analytics-page">
        <div className="container">

          <div className="container">

          <div className="flex-center">
            <div className="m-3 content-section container">
              <div className="text-center">
                <span className="text-size-1 text-dark">Analytics are disabled on your account. </span>
                <span className="text-size-1 text-quaternary"><Link to="/billing">Upgrade your plan</Link> </span>
                <span className="text-size-1 text-dark">to gain access.</span>
              </div>
            </div>
          </div>

          </div>

          <hr className="my-3" />

        </div>
      </ContentLayout>
    )
  }
}

export default withRouter(Page);